import { OpenModalEvent } from '@ui-common/components/Modal'
import { ModalVisualMode } from '@ui-components/containers/ModalTypes'
import { BodyText } from '@ui-components/typography/Typography'
import { IntlShape } from 'react-intl'

export const getIfpExitDuringSendStepModalEvent = ({
  onAbort,
  onCancel,
  intl,
}: {
  onAbort: () => void
  onCancel: () => void
  intl: IntlShape
}): OpenModalEvent => {
  return {
    type: 'OPEN',
    data: {
      header: intl.formatMessage({ id: 'sec-loans-abort-tired-of-waiting-prompt-header' }),
      children: (
        <BodyText tagName="div">
          {intl.formatMessage({ id: 'sec-loans-abort-tired-of-waiting-prompt-message' })}
        </BodyText>
      ),
      primaryButtonOptions: {
        label: intl.formatMessage({ id: 'common-cancel' }),
        onClick: onCancel,
      },
      secondaryButtonOptions: {
        label: intl.formatMessage({ id: 'common-abort-prompt-exit' }),
        onClick: onAbort,
      },
      mode: ModalVisualMode.Help,
    },
  }
}
